import { Validators } from '@angular/forms';

export interface OfferFieldConfig {
    key: string;
    label: string;
    type?: 'text' | 'number' | 'textarea';
    validators?: any[];
    defaultValue?: any;
    patternHint?: string;
}

export const OFFER_FIELDS: OfferFieldConfig[] = [
    {
        key: 'SalePrice', label: 'Sale Price', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    {
        key: 'AdRetailPrice', label: 'Retail Price', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    { key: 'UnitOfMeasure', label: 'Unit Of Measure', type: 'text', defaultValue: '' },
    {
        key: 'Quantity', label: 'Quantity', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99)],
        patternHint: "Only numbers from 0 to 99 are allowed."
    },
    {
        key: 'PercentOff', label: 'Percent Off', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99)],
        patternHint: "Only numbers from 0 to 99 are allowed."
    },
    {
        key: 'DollarOff', label: 'Dollar Off', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    {
        key: 'BuyQuantity', label: 'Buy Quantity', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99), Validators.pattern(/^\d{1,2}$/)],
        patternHint: "Only whole numbers from 0 to 99 are allowed."
    },
    {
        key: 'GetQuantity', label: 'Get Quantity', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99), Validators.pattern(/^\d{1,2}$/)],
        patternHint: "Only whole numbers from 0 to 99 are allowed."
    },
    {
        key: 'WhenYouBuy', label: 'When You Buy', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99), Validators.pattern(/^\d{1,2}$/)],
        patternHint: "Only whole numbers from 0 to 99 are allowed."
    },
    {
        key: 'Limit', label: 'Limit', type: 'text', defaultValue: '',
        validators: [Validators.minLength(1), Validators.maxLength(100), Validators.pattern("[a-zA-Z0-9 \\-#&*\\'/.,;]*")],
        patternHint: "Only letters, numbers, spaces and - # & * ' / . , ; are allowed."
    },
    {
        key: 'SaveAmount', label: 'Save Amount', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    {
        key: 'CustomPricingText', label: 'Custom Pricing Text', type: 'textarea', defaultValue: ''
    },
    {
        key: 'MaxSave', label: 'Max Save', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    {
        key: 'MinSave', label: 'Min Save', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    {
        key: 'PercentAmount', label: 'Percent Amount', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99)],
        patternHint: "Only numbers from 0 to 99 are allowed."
    },
    {
        key: 'SavePercent', label: 'Save Percent', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(99)],
        patternHint: "Only numbers from 0 to 99 are allowed."
    },
    {
        key: 'SaveStandard', label: 'Save Standard', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    },
    {
        key: 'SpendAmount', label: 'Spend Amount', type: 'number', defaultValue: -1,
        validators: [Validators.min(0), Validators.max(9999999)],
        patternHint: "Only numbers from 0 to 9,999,999 are allowed."
    }
];

export const DEFAULT_OFFER_TYPE_FIELD_MAP: Record<string, string[]> = {
    PRICE_STD: ['SalePrice', 'AdRetailPrice', 'MaxSave', 'MinSave', 'BuyQuantity', 'UnitOfMeasure', 'CustomPricingText', 'SaveAmount'],
    X_FOR: ['SalePrice', 'Quantity', 'UnitOfMeasure', 'AdRetailPrice', 'BuyQuantity', 'CustomPricingText', 'SaveAmount'],
    BOGO: ['BuyQuantity', 'GetQuantity', 'CustomPricingText', 'AdRetailPrice', 'PercentOff', 'SaveAmount'],
    BXGY: ['BuyQuantity', 'GetQuantity', 'PercentOff', 'MinSave', 'SalePrice', 'CustomPricingText', 'AdRetailPrice', 'SaveAmount'],
    NET_DOWN: ['SalePrice', 'AdRetailPrice', 'SaveAmount', 'UnitOfMeasure', 'BuyQuantity', 'Quantity', 'PercentAmount', 'CustomPricingText'],
    SAVE: ['SavePercent', 'SalePrice', 'MaxSave', 'MinSave', 'SaveAmount', 'BuyQuantity', 'Quantity', 'SpendAmount', 'SaveStandard', 'CustomPricingText', 'WhenYouBuy', 'AdRetailPrice'],
    PERCENT_OFF: ['PercentOff', 'MaxSave', 'BuyQuantity', 'AdRetailPrice', 'CustomPricingText', 'UnitOfMeasure','SalePrice'],
    DOLLAR_OFF: ['AdRetailPrice', 'DollarOff', 'SpendAmount', 'Quantity', 'SaveAmount', 'CustomPricingText', 'UnitOfMeasure'],
    NO_PRICE: ['CustomPricingText'],
    NOW: ['SalePrice'],
    SAVE_UP_TO: ['SaveAmount', 'PercentOff'],
    None: []
};

export const ORG_OFFER_TYPE_FIELD_MAP: Record<string, Partial<Record<keyof typeof DEFAULT_OFFER_TYPE_FIELD_MAP, string[]>>> = {
    // Standard: {
    //     BOGO: ['MaxSave', 'MinSave', 'SalePrice'], // Example of overriding fields for a specific organization
    // }
     Schnucks: {
     PRICE_STD: ['SalePrice', 'AdRetailPrice', 'MaxSave', 'MinSave', 'BuyQuantity', 'UnitOfMeasure', 'CustomPricingText', 'SaveAmount', 'WhenYouBuy'],
     X_FOR: ['SalePrice', 'Quantity', 'UnitOfMeasure', 'AdRetailPrice', 'BuyQuantity', 'CustomPricingText', 'WhenYouBuy'],
 },
};

export function getOfferPricingFieldKeys(offerType: keyof typeof DEFAULT_OFFER_TYPE_FIELD_MAP, orgName: string): string[] {
    const defaultFields = DEFAULT_OFFER_TYPE_FIELD_MAP[offerType] || [];
    const orgOverride = ORG_OFFER_TYPE_FIELD_MAP[orgName]?.[offerType];

    return orgOverride ?? defaultFields;
}

export function getOfferPricingFields(offerType: keyof typeof DEFAULT_OFFER_TYPE_FIELD_MAP | string, orgName: string): OfferFieldConfig[] {
    const offerTypeExists = !!DEFAULT_OFFER_TYPE_FIELD_MAP[offerType as keyof typeof DEFAULT_OFFER_TYPE_FIELD_MAP];

    if (!offerTypeExists) {
        return [...new Map(OFFER_FIELDS.map(field => [field.key, field])).values()];
    }

    const keys = getOfferPricingFieldKeys(offerType as keyof typeof DEFAULT_OFFER_TYPE_FIELD_MAP, orgName);
    const keySet = new Set(keys);

    return OFFER_FIELDS.filter(field => keySet.has(field.key));
}


